import './TimingClock.css';
import TimingClock from '../../components/TimingClock';

import { connect } from 'react-redux';
import React from 'react';
//import { createSelector } from 'reselect';
import { pick } from 'lodash';

const TimingClockDisplay = ({ timingClock }) => {
  return (
    <main className="nosturi timing-clock page">
      <div className="clearfix" style={{ textAlign: 'center' }}>
        <div
          style={{
            display: 'inline-block',
            color: 'white',
            background: 'blue',
          }}
        >
          <TimingClock {...timingClock} size="massive" mute={true} />
        </div>
      </div>
    </main>
  );
};

TimingClockDisplay.slug = 'timing-clock';
TimingClockDisplay.title = 'Timing clock';

const mapStateToProps = ({ venue, orm }) => ({
  ...pick(venue.competition, 'timingClock'),
});

export default connect(mapStateToProps)(TimingClockDisplay);



// WEBPACK FOOTER //
// ./src/displays/TimingClock/TimingClock.js